<template>
    <div class="result-hero-wrapper">
        <div class="container">
            <div class="col result-hero-container">
                <div class="result-hero-details">
                    <div class="details">
                        <div class="title">
                            <span class="greetingDetail">
                                {{ title }}
                            </span>
                        </div>

                        <div class="details-description">
                            <span>{{ subtitle }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'subtitle'],
}
</script>
